import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { LangProvider } from './context/LangContext';
import { AuthProvider } from './context/AuthContext';
import Landing   from './pages/Landing';
import AppPage   from './pages/AppPage';
import Login     from './pages/Login';
import Register  from './pages/Register';
import Dashboard from './pages/Dashboard';
import Pricing   from './pages/Pricing';
import NotFound  from './pages/NotFound';
import AdminPage          from './pages/AdminPage';
import LearningCenterPage from './pages/LearningCenterPage';

export default function App() {
  return (
    <AuthProvider>
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/"          element={<Landing />} />
            <Route path="/login"     element={<Login />} />
            <Route path="/register"  element={<Register />} />
            <Route path="/pricing"   element={<Pricing />} />
            <Route path="/app"       element={<AppPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin"     element={<AdminPage />} />
            <Route path="/learning"  element={<LearningCenterPage />} />
            <Route path="*"          element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#1a1a2e',
              color: '#f0f0f5',
              border: '1px solid rgba(255,255,255,0.1)',
              fontFamily: 'Tajawal, sans-serif',
              fontSize: '14px',
            },
          }}
        />
      </LangProvider>
    </AuthProvider>
  );
}
